module.exports = __webpack_public_path__ + "static/img/na.bb49a403.svg";